// extracted by mini-css-extract-plugin
export default {"organImgContainer":"HumanFigureOrgans_organImgContainer__qs7Q9","organImg":"HumanFigureOrgans_organImg__QsnvW"};